module.exports = __webpack_public_path__ + "img/list9.0b651e9c.jpg";